module.exports = {
  "pageView": {
    "name": "page-view",
    "class": "view",
    "properties": {
      "screen": "string",
      "host": "boolean",
      "ousideMeeting": "boolean",
      "pastMeeting": "boolean"
    },
    "namespace": "in-meeting-experience-app",
    "version": "1"
  },
  "usage": {
    "name": "usage",
    "class": "usage",
    "properties": {
      "name": "string",
      "screen": "string",
      "isNew": {
        "type": "boolean",
        "isOptional": true
      },
      "type": {
        "type": [
          "contact",
          "company",
          "deal",
          "ticket",
          "tab",
          "modal"
        ],
        "isOptional": true
      },
      "description": "string",
      "playbookId": {
        "type": "number",
        "isOptional": true
      },
      "host": "boolean",
      "ousideMeeting": "boolean",
      "pastMeeting": "boolean",
      "integrationStatus": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "in-meeting-experience-app",
    "version": "1"
  },
  "interaction": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "screen": "string",
      "description": "string",
      "type": {
        "type": [
          "contact",
          "company",
          "deal",
          "ticket",
          "tab",
          "modal"
        ],
        "isOptional": true
      },
      "host": "boolean",
      "ousideMeeting": "boolean",
      "pastMeeting": "boolean"
    },
    "namespace": "in-meeting-experience-app",
    "version": "1"
  }
};